import {MedicationProfileFormSchema} from '@/modules/drug-catalog/medication-profiles/schemas'
import {SortSchema} from '@cypro/ui/schemas'
import {
  DoseCalcModeActive,
  DurationUnit,
  OverdosePreventionLevel,
  PreparationType,
  RoundingMode,
} from '@cypro/engine/database/schema'
import {AddActiveSubstanceSchema} from '@cypro/engine/mutators'
import {NO_CATEGORIES_FILTER} from '@cypro/engine/queries'
import * as z from 'zod'

export const NewActiveSubstancePageSearchSchema = z.object({
  substanceId: z.uuidv7().optional(),
})

export const ActiveSubstancesSearchSchema = z.object({
  filters: z
    .object({
      search: z.string().optional(),
      categories: z.array(z.uuidv7().or(z.literal(NO_CATEGORIES_FILTER))).optional(),
      calculationMethod: z.array(DoseCalcModeActive).optional(),
      unit: z.array(z.uuidv7()).optional(),
    })
    .optional(),
  sort: z.array(SortSchema).default([{id: 'name', desc: false}]),
})

export const ActiveSubstanceFormSchema = AddActiveSubstanceSchema.omit({
  doseCalculationMethod: true,
  doseUnitId: true,
  hazardClassId: true,
  roundingMode: true,
  minIntervalUnit: true,
  overdosePreventionLevel: true,
  medicationProfiles: true,
  preparationType: true,
}).extend({
  doseCalculationMethod: z.array(DoseCalcModeActive).nonempty(),
  roundingMode: z.array(RoundingMode).nonempty(),
  minIntervalUnit: z.array(DurationUnit),
  overdosePreventionLevel: z.array(OverdosePreventionLevel).nonempty(),
  doseUnitId: z.array(z.uuidv7()).nonempty(),
  hazardClassId: z.array(z.uuidv7()),
  preparationType: z.array(PreparationType),
  medicationProfiles: z.array(MedicationProfileFormSchema).nonempty(),
})

export type ActiveSubstanceFormSchema = z.infer<typeof ActiveSubstanceFormSchema>
